import MainContent from "components/layout/MainContent";
import AppLoader from "components/common/AppLoader";
import DelayedSpinner from "components/common/DelayedSpinner";
import { PageProvider } from "contexts/PageContext";
import AppModal from "components/common/AppModal";
import { useAuth } from "contexts/AuthContext";
import { Button } from "design-system/Button/Button";
import NavBar from "components/layout/Navbar";
import Footer from "components/layout/Footer";
import { useAppUI } from "contexts/UIContext";
import Analytics from "../Analytics";
import "./styles.scss";



function RootPage() {
  const { modalProps, appLoading } = useAppUI();
  const { token, loading, error, signedOut, signIn } = useAuth();

  if (signedOut) {
    return (
      <div className="indexpage">
        <p>You are signed out of WesternAva.</p>
        <Button variant="primary" iconLeft="bi-box-arrow-in-right" onClick={signIn}>
          Sign in
        </Button>
      </div>
    );
  }

  if (loading) {
    return <DelayedSpinner fullHeight />;
  }

  if (error) {
    return (
      <div className="indexpage">
        {error}
      </div>
    );
  }

  if (!token) {
    return (
      <div className="indexpage">
        Not authenticated. Please refresh and login.
      </div>
    );
  }



  return (
    <>
      {/* Analytics */}
      <Analytics />

      {/* Page Content */}
      <div id="rootPage">
        <PageProvider>
          <NavBar />
          <MainContent />
        </PageProvider>
        <Footer />
      </div>

      {/* Modal */}
      {modalProps ? (
        <AppModal {...modalProps} />
      ) : null}

      {/* Loader */}
      {appLoading ? (
        <AppLoader />
      ) : null}
    </>
  );
}

export default RootPage;